/* Access Models RC guided selling | rcgs-offline-2026-07-27-v7-14ae9c5e39f2 | offline candidate */
(function(){
'use strict';
const FORBIDDEN_COMPONENT_TYPES = new Set(['body_shell', 'body', 'body-shell', 'bodies']);
const CHOICE_ROLES = new Set(['required_choice', 'complete_setup_choice']);
const MANDATORY_ROLES = new Set(['required', 'required_setup_extra']);
const ALLOWED_COMPONENT_TYPES = new Set(['battery', 'charger', 'charger_power_supply', 'complete_battery_charger_pack', 'transmitter_batteries', 'accessory']);
const ALLOWED_ROLES = new Set([...CHOICE_ROLES, ...MANDATORY_ROLES, 'recommended_spare', 'replacement', 'compatible_alternative', 'optional']);
const ANALYTICS_EVENTS = new Set([
  'rcgs_impression',
  'rcgs_data_load_succeeded',
  'rcgs_data_load_failed',
  'rcgs_vehicle_selected',
  'rcgs_step_viewed',
  'rcgs_accessory_selected',
  'rcgs_accessory_deselected',
  'rcgs_required_choice_changed',
  'rcgs_live_check_succeeded',
  'rcgs_live_check_failed',
  'rcgs_package_reviewed',
  'rcgs_product_link_clicked',
  'rcgs_package_action_blocked',
]);
const ANALYTICS_FIELDS = new Set([
  'releaseId', 'schemaVersion', 'surface', 'vehicleSku', 'accessorySku',
  'componentType', 'role', 'step', 'reasonCode', 'valuePence', 'currency',
  'itemCount', 'success',
]);

function error(code, detail = '') {
  return { code, detail };
}

function deriveHandle(url) {
  if (typeof url !== 'string') return null;
  let parsed;
  try { parsed = new URL(url); } catch { return null; }
  if (parsed.protocol !== 'https:' || parsed.hostname !== 'accessmodels.co.uk') return null;
  if (parsed.search || parsed.hash) return null;
  const match = parsed.pathname.match(/^\/products\/([a-z0-9][a-z0-9-]*)\/?$/);
  return match ? match[1] : null;
}

function findVehicleByExactSku(dataset, anchorSku) {
  if (!dataset || !Array.isArray(dataset.vehicles) || typeof anchorSku !== 'string') return null;
  const matches = dataset.vehicles.filter(vehicle => vehicle.anchorSku === anchorSku);
  return matches.length === 1 ? matches[0] : null;
}

function validatePublicDataset(dataset, expectedReleaseId = null) {
  const errors=[];const fail=(code,detail='')=>errors.push(detail?code+':'+detail:code);const same=(a,b)=>Array.isArray(a)&&Array.isArray(b)&&a.length===b.length&&a.every((x,i)=>x===b[i]);
  const ALL=["C-ARA3230ST1","CA80468","C-LOS-1392T2","FTX5470BK","FTX5533B","FTX5576B","FTX5576O","FTX5576R","FTX5577G","FTX5577R","TRX68154-4-GRN","TRX88296-4-BLK","TRX97054-1-XBLU","C-ARA2130T1","C-ARA2130T3","C-ARA2104T1","C-ARA2104T2","C-ARA2130T2","FTX5470W","FTX5475B","FTX5475R","FTX5497GB","FTX5596B","FTX5596R","FTX5596Y","FTX5472BL","FTX5472OR","FTX5563"],TEN=["FTX5470BK","FTX5533B","FTX5576B","FTX5576O","FTX5576R","FTX5577G","FTX5577R","TRX68154-4-GRN","TRX88296-4-BLK","TRX97054-1-XBLU"];
  if(dataset?.schemaVersion!=='2.1.0')fail('CONTRACT_VERSION_INVALID');if(dataset?.contractId!=='am-rc-product-pages/v1')fail('CONTRACT_ID_INVALID');if(dataset?.releaseId!==expectedReleaseId||!/^rcgs-product-pages-\d{4}-\d{2}-\d{2}-v\d+-[a-f0-9]{12}$/.test(dataset?.releaseId||''))fail('RELEASE_ID_INVALID');if(dataset?.releaseState!=='product-page-expansion-candidate')fail('RELEASE_STATE_INVALID');if(dataset?.rules?.exactSkuOnly!==true||dataset?.rules?.liveCommerceValidationRequired!==true)fail('SAFETY_RULES_INVALID');if(dataset?.rules?.liveCartEnabled!==false||dataset?.rules?.liveAccessoryCartEnabled!==true||dataset?.rules?.accessoryCartReleaseState!=='live_approved')fail('CART_RULES_INVALID');if(!same(dataset?.productPageSkus,ALL)||!same(dataset?.configuratorSkus,TEN))fail('SCOPE_INVALID');if(dataset?.summary?.vehicles!==ALL.length||dataset?.summary?.configuratorVehicles!==TEN.length||dataset?.summary?.relationships!==62)fail('SUMMARY_INVALID');if(!Array.isArray(dataset?.vehicles)||!same(dataset.vehicles.map(v=>v.anchorSku),ALL))fail('ANCHORS_INVALID');let count=0;const validAnchors=[];for(const v of dataset?.vehicles||[]){let valid=typeof v.anchorSku==='string'&&/^\d+$/.test(String(v.productId))&&/^\d+$/.test(String(v.variantId))&&/^[a-z0-9][a-z0-9-]*$/.test(v.handle||'')&&Array.isArray(v.relationships);const seen=new Set();count+=v.relationships?.length||0;const heldMissing={FTX5472BL:'charger',FTX5472OR:'charger','TRX68154-4-GRN':'transmitter_batteries','TRX88296-4-BLK':'transmitter_batteries','TRX97054-1-XBLU':'transmitter_batteries'},expectedMissing=heldMissing[v.anchorSku]?[heldMissing[v.anchorSku]]:[];if(!same(v.setup?.missingRequiredComponents,expectedMissing)||(expectedMissing.length>0&&v.setup?.completePackageEligible!==false))valid=false;for(const r of v.relationships||[]){const sku=r?.accessorySku,quantity=r?.quantity===undefined?1:r.quantity;if(!sku||r.sku!==sku||seen.has(sku)||!/^\d+$/.test(String(r.productId))||!/^\d+$/.test(String(r.variantId))||!/^[a-z0-9][a-z0-9-]*$/.test(r.handle||'')||r.visibility!=='eligible'||String(r.componentType||'').toLowerCase().includes('body')||!Number.isInteger(quantity)||quantity<1||quantity>10)valid=false;seen.add(sku)}if(valid)validAnchors.push(v.anchorSku);else fail('ANCHOR_CONTRACT_INVALID',v.anchorSku)}if(count!==62)fail('RELATIONSHIP_COUNT_INVALID');return {ok:errors.length===0,errors,validAnchors};
}

function customerRelationships(vehicle) {
  if (!vehicle || !Array.isArray(vehicle.relationships)) return [];
  return vehicle.relationships
    .filter(rel => rel && rel.visibility === 'eligible')
    .filter(rel => typeof rel.componentType === 'string' && !FORBIDDEN_COMPONENT_TYPES.has(rel.componentType))
    .filter(rel => !rel.componentType.toLowerCase().includes('body'))
    .filter(rel => typeof rel.accessorySku === 'string' && rel.accessorySku.length > 0)
    .sort((a, b) => (Number(a.displayPriority) - Number(b.displayPriority)) || a.accessorySku.localeCompare(b.accessorySku));
}

function relationshipQuantity(rel) {
  return rel?.quantity === undefined ? 1 : rel.quantity;
}

function choiceKey(rel) {
  return `${rel.role}:${rel.componentType}`;
}

function createInitialSelection(vehicle) {
  const relationships = customerRelationships(vehicle);
  const selected = new Set();
  const locked = new Set();
  const choiceGroups = new Map();

  for (const rel of relationships) {
    if (MANDATORY_ROLES.has(rel.role)) {
      selected.add(rel.accessorySku);
      locked.add(rel.accessorySku);
    } else if (CHOICE_ROLES.has(rel.role)) {
      const key = choiceKey(rel);
      if (!choiceGroups.has(key)) choiceGroups.set(key, []);
      choiceGroups.get(key).push(rel);
    }
  }

  for (const options of choiceGroups.values()) {
    options.sort((a, b) => (Number(a.displayPriority) - Number(b.displayPriority)) || a.accessorySku.localeCompare(b.accessorySku));
    if (options[0]) selected.add(options[0].accessorySku);
  }

  return { selected, locked };
}

function reduceSelection(vehicle, state, action) {
  const relationships = customerRelationships(vehicle);
  const bySku = new Map(relationships.map(rel => [rel.accessorySku, rel]));
  const next = { selected: new Set(state?.selected || []), locked: new Set(state?.locked || []) };
  const rel = bySku.get(action?.sku);
  if (!rel) return { state: next, error: 'UNKNOWN_ACCESSORY_SKU' };

  if (action.type === 'SELECT_CHOICE') {
    if (!CHOICE_ROLES.has(rel.role)) return { state: next, error: 'NOT_A_CHOICE' };
    const key = choiceKey(rel);
    for (const candidate of relationships) {
      if (CHOICE_ROLES.has(candidate.role) && choiceKey(candidate) === key) next.selected.delete(candidate.accessorySku);
    }
    next.selected.add(rel.accessorySku);
    return { state: next, error: null };
  }

  if (action.type === 'TOGGLE_OPTIONAL') {
    if (next.locked.has(rel.accessorySku) || MANDATORY_ROLES.has(rel.role)) {
      next.selected.add(rel.accessorySku);
      return { state: next, error: 'MANDATORY_ITEM_LOCKED' };
    }
    if (CHOICE_ROLES.has(rel.role)) return { state: next, error: 'CHOICE_REQUIRES_SELECT_ACTION' };
    if (next.selected.has(rel.accessorySku)) next.selected.delete(rel.accessorySku);
    else next.selected.add(rel.accessorySku);
    return { state: next, error: null };
  }

  return { state: next, error: 'UNKNOWN_SELECTION_ACTION' };
}

function validateSelection(vehicle, state) {
  const relationships = customerRelationships(vehicle);
  const allowed = new Map(relationships.map(rel => [rel.accessorySku, rel]));
  const selected = state?.selected instanceof Set ? state.selected : new Set();
  const errors = [];

  for (const sku of selected) {
    if (!allowed.has(sku)) errors.push(error('RELATIONSHIP_NOT_ELIGIBLE', sku));
  }

  const groups = new Map();
  for (const rel of relationships) {
    if (MANDATORY_ROLES.has(rel.role) && !selected.has(rel.accessorySku)) {
      errors.push(error('MANDATORY_ITEM_MISSING', rel.accessorySku));
    }
    if (CHOICE_ROLES.has(rel.role)) {
      const key = choiceKey(rel);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(rel);
    }
  }

  for (const [key, options] of groups) {
    const count = options.filter(rel => selected.has(rel.accessorySku)).length;
    if (count === 0) errors.push(error('REQUIRED_CHOICE_MISSING', key));
    if (count > 1) errors.push(error('REQUIRED_CHOICE_MULTIPLE', key));
  }

  return { ok: errors.length === 0, errors };
}

function createInitialAccessorySelection(_vehicle) {
  return { selected: new Set(), locked: new Set() };
}

function reduceAccessorySelection(vehicle, state, action) {
  const relationships = customerRelationships(vehicle);
  const bySku = new Map(relationships.map(rel => [rel.accessorySku, rel]));
  const next = { selected: new Set(state?.selected || []), locked: new Set() };
  const rel = bySku.get(action?.sku);
  if (!rel) return { state: next, error: 'UNKNOWN_ACCESSORY_SKU' };
  if (action?.type === 'TOGGLE_ACCESSORY') {
    if (CHOICE_ROLES.has(rel.role)) {
      if (next.selected.has(rel.accessorySku)) {
        next.selected.delete(rel.accessorySku);
      } else {
        const key = choiceKey(rel);
        for (const candidate of relationships) {
          if (CHOICE_ROLES.has(candidate.role) && choiceKey(candidate) === key) next.selected.delete(candidate.accessorySku);
        }
        next.selected.add(rel.accessorySku);
      }
      return { state: next, error: null };
    }
    if (next.selected.has(rel.accessorySku)) next.selected.delete(rel.accessorySku);
    else next.selected.add(rel.accessorySku);
    return { state: next, error: null };
  }
  if (action?.type === 'SELECT_CHOICE') {
    if (!CHOICE_ROLES.has(rel.role)) return { state: next, error: 'NOT_A_CHOICE' };
    const key = choiceKey(rel);
    for (const candidate of relationships) {
      if (CHOICE_ROLES.has(candidate.role) && choiceKey(candidate) === key) next.selected.delete(candidate.accessorySku);
    }
    next.selected.add(rel.accessorySku);
    return { state: next, error: null };
  }
  if (action?.type === 'TOGGLE_OPTIONAL') {
    if (CHOICE_ROLES.has(rel.role)) return { state: next, error: 'CHOICE_REQUIRES_SELECT_ACTION' };
    if (next.selected.has(rel.accessorySku)) next.selected.delete(rel.accessorySku);
    else next.selected.add(rel.accessorySku);
    return { state: next, error: null };
  }
  return { state: next, error: 'UNKNOWN_SELECTION_ACTION' };
}

function validateAccessorySelection(vehicle, state) {
  const relationships = customerRelationships(vehicle);
  const allowed = new Map(relationships.map(rel => [rel.accessorySku, rel]));
  const selected = state?.selected instanceof Set ? state.selected : new Set();
  const errors = [];
  for (const sku of selected) if (!allowed.has(sku)) errors.push(error('RELATIONSHIP_NOT_ELIGIBLE', sku));
  const groups = new Map();
  for (const rel of relationships.filter(item => CHOICE_ROLES.has(item.role))) {
    const key = choiceKey(rel);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(rel);
  }
  for (const [key, options] of groups) {
    if (options.filter(rel => selected.has(rel.accessorySku)).length > 1) errors.push(error('ACCESSORY_CHOICE_MULTIPLE', key));
  }
  return { ok: errors.length === 0, errors };
}

function buildAccessoryPlan(vehicle, state) {
  const selectionCheck = validateAccessorySelection(vehicle, state);
  if (!selectionCheck.ok) return { ok: false, errors: selectionCheck.errors };
  const lines = customerRelationships(vehicle)
    .filter(rel => state?.selected?.has(rel.accessorySku))
    .map(rel => ({ ...rel, kind: 'accessory', sku: rel.accessorySku, quantity: relationshipQuantity(rel) }));
  if (lines.length === 0) return { ok: false, errors: [error('ACCESSORY_SELECTION_EMPTY')] };
  return { ok: true, errors: [], value: lines };
}

function validateRuntimeProduct(expected, productJs) {
  const errors = [];
  if (!expected || !productJs || typeof productJs !== 'object' || !Array.isArray(productJs.variants)) {
    return { ok: false, errors: [error('PRODUCT_JS_INVALID')] };
  }

  if (String(productJs.id) !== String(expected.productId)) errors.push(error('PRODUCT_ID_MISMATCH'));
  if (productJs.handle !== expected.handle) errors.push(error('HANDLE_MISMATCH'));

  const expectedSku = expected.sku || expected.accessorySku || expected.anchorSku;
  if (expected.variantId == null || !/^\d+$/.test(String(expected.variantId))) errors.push(error('EXPECTED_VARIANT_ID_MISSING'));
  const skuMatches = productJs.variants.filter(variant => variant && variant.sku === expectedSku);
  if (skuMatches.length === 0) errors.push(error('SKU_MISMATCH'));
  if (skuMatches.length > 1) errors.push(error('SKU_AMBIGUOUS'));
  const variant = skuMatches.length === 1 ? skuMatches[0] : null;

  if (variant && expected.variantId != null && String(variant.id) !== String(expected.variantId)) {
    errors.push(error('VARIANT_ID_MISMATCH'));
  }
  if (variant && variant.available !== true) errors.push(error('PRODUCT_UNAVAILABLE'));
  if (variant && (!Number.isInteger(variant.price) || variant.price < 0)) errors.push(error('PRICE_INVALID'));

  if (errors.length) return { ok: false, errors };
  return {
    ok: true,
    errors: [],
    value: {
      productId: String(productJs.id),
      variantId: String(variant.id),
      handle: productJs.handle,
      sku: expectedSku,
      available: true,
      pricePence: variant.price,
      title: typeof productJs.title === 'string' ? productJs.title : expected.title,
      image: typeof productJs.featured_image === 'string' ? productJs.featured_image : null,
      url: `/products/${expected.handle}`,
    },
  };
}

function buildPackagePlan(vehicle, state) {
  if (vehicle?.setup?.completePackageEligible !== true || !Array.isArray(vehicle.setup.missingRequiredComponents) || vehicle.setup.missingRequiredComponents.length !== 0) {
    return { ok: false, errors: [error('PACKAGE_INCOMPLETE')] };
  }
  const selectionCheck = validateSelection(vehicle, state);
  if (!selectionCheck.ok) return { ok: false, errors: selectionCheck.errors };
  const relationships = customerRelationships(vehicle);
  const lines = [{
    kind: 'vehicle',
    sku: vehicle.anchorSku,
    productId: String(vehicle.productId),
    variantId: vehicle.variantId ? String(vehicle.variantId) : null,
    handle: vehicle.handle,
    title: vehicle.title,
    vendor: vehicle.vendor,
    componentType: 'vehicle',
    role: 'anchor',
    displayPriority: -1,
    quantity: 1,
  }];
  for (const rel of relationships) {
    if (!state.selected.has(rel.accessorySku)) continue;
    lines.push({ ...rel, kind: 'accessory', sku: rel.accessorySku, quantity: relationshipQuantity(rel) });
  }
  return { ok: true, errors: [], value: lines };
}

function buildCartPayload(plan, validatedProducts) {
  const errors = [];
  if (!Array.isArray(plan) || !(validatedProducts instanceof Map)) {
    return { ok: false, errors: [error('PACKAGE_VALIDATION_FAILED')] };
  }
  const items = [];
  const ids = new Set();
  for (const line of plan) {
    if (!Number.isInteger(line?.quantity) || line.quantity < 1 || line.quantity > 10) { errors.push(error('RELATIONSHIP_QUANTITY_INVALID', line?.sku || '')); continue; }
    const live = validatedProducts.get(line.sku);
    if (!live || live.available !== true || typeof live.variantId !== 'string') {
      errors.push(error('PACKAGE_VALIDATION_FAILED', line.sku));
      continue;
    }
    if (ids.has(live.variantId)) {
      errors.push(error('DUPLICATE_CART_VARIANT', live.variantId));
      continue;
    }
    ids.add(live.variantId);
    items.push({ id: live.variantId, quantity: line.quantity });
  }
  if (errors.length || items.length !== plan.length) return { ok: false, errors };
  return { ok: true, errors: [], value: { items } };
}

function resolveLiveCartEnabled(value) {
  return value === true;
}

function makeAnalyticsEvent(eventName, context = {}) {
  if (!ANALYTICS_EVENTS.has(eventName)) throw new Error(`Unknown analytics event: ${eventName}`);
  const event = { event: eventName };
  for (const [key, value] of Object.entries(context)) {
    if (!ANALYTICS_FIELDS.has(key)) continue;
    if (['string', 'number', 'boolean'].includes(typeof value) && value !== '') event[key] = value;
  }
  return event;
}

const constants = Object.freeze({
  CHOICE_ROLES: [...CHOICE_ROLES],
  MANDATORY_ROLES: [...MANDATORY_ROLES],
  ANALYTICS_EVENTS: [...ANALYTICS_EVENTS],
});


const HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]*$/;

async function loadProductJs(handle, {
  fetchImpl = globalThis.fetch,
  root = '/',
  timeoutMs = 8000,
} = {}) {
  if (typeof handle !== 'string' || !HANDLE_PATTERN.test(handle)) throw new Error('Invalid product handle');
  if (typeof fetchImpl !== 'function') throw new Error('No fetch implementation');
  const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const freshUrl = `${normalizedRoot}products/${encodeURIComponent(handle)}.js?_rcgs=${Date.now()}`;
    const response = await fetchImpl(freshUrl, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
      signal: controller.signal,
    });
    if (!response || response.ok !== true) throw new Error(`Product lookup failed (${response?.status || 'network'})`);
    const data = await response.json();
    if (!data || typeof data !== 'object') throw new Error('Invalid product response');
    return data;
  } finally {
    clearTimeout(timer);
  }
}

async function validateEntirePackage(plan, {
  loadExpectedProduct,
  fetchImpl = globalThis.fetch,
  root = '/',
  timeoutMs = 8000,
} = {}) {
  if (!Array.isArray(plan) || plan.length === 0) return { ok: false, errors: [{ code: 'PACKAGE_VALIDATION_FAILED' }] };
  const loader = typeof loadExpectedProduct === 'function'
    ? loadExpectedProduct
    : expected => loadProductJs(expected.handle, { fetchImpl, root, timeoutMs });
  const settled = await Promise.allSettled(plan.map(async expected => {
    const product = await loader(expected);
    const check = validateRuntimeProduct(expected, product);
    if (!check.ok) return { expected, errors: check.errors };
    return { expected, value: check.value };
  }));

  const errors = [];
  const validated = new Map();
  for (let index = 0; index < settled.length; index += 1) {
    const result = settled[index];
    const expected = plan[index];
    if (result.status === 'rejected') {
      errors.push({ code: 'LIVE_PRODUCT_LOOKUP_FAILED', detail: expected.sku });
      continue;
    }
    if (result.value.errors) {
      errors.push(...result.value.errors.map(item => ({ ...item, detail: `${expected.sku}${item.detail ? `:${item.detail}` : ''}` })));
      continue;
    }
    validated.set(expected.sku, result.value.value);
  }
  if (errors.length || validated.size !== plan.length) return { ok: false, errors };
  return { ok: true, errors: [], value: validated };
}

async function preparePackage(plan, options = {}) {
  if (options.completePackageEligible !== true || typeof options.releaseId !== 'string' || options.releaseId.length < 1) {
    return { ok: false, errors: [{ code: 'PACKAGE_GATE_INVALID' }] };
  }
  const live = await validateEntirePackage(plan, options);
  if (!live.ok) return { ok: false, errors: live.errors };
  const payload = buildCartPayload(plan, live.value);
  if (!payload.ok) return { ok: false, errors: payload.errors };
  const packageKey = `${options.releaseId}:${payload.value.items.map(item => `${item.id}x${item.quantity}`).join(',')}`;
  return { ok: true, errors: [], releaseId: options.releaseId, completePackageEligible: true, packageKey, payload: payload.value, liveProducts: live.value };
}

async function prepareAccessories(plan, options = {}) {
  if (options.surface !== 'product' || typeof options.releaseId !== 'string' || options.releaseId.length < 1 || !Array.isArray(plan) || plan.length === 0 || plan.some(line => line?.kind !== 'accessory')) {
    return { ok: false, errors: [{ code: 'ACCESSORY_GATE_INVALID' }] };
  }
  const live = await validateEntirePackage(plan, options);
  if (!live.ok) return { ok: false, errors: live.errors };
  const payload = buildCartPayload(plan, live.value);
  if (!payload.ok) return { ok: false, errors: payload.errors };
  const accessoryCartKey = `${options.releaseId}:${payload.value.items.map(item => `${item.id}x${item.quantity}`).join(',')}`;
  return { ok: true, errors: [], releaseId: options.releaseId, surface: 'product', accessoryOnly: true, accessoryCartKey, payload: payload.value, liveProducts: live.value };
}

async function attemptPackageAction({ liveCartEnabled = false } = {}) {
  if (!resolveLiveCartEnabled(liveCartEnabled)) return { ok: false, code: 'LIVE_CART_DISABLED' };
  return { ok: false, code: 'CART_ADAPTER_NOT_INSTALLED' };
}

(function registerAMRcGuided() {
  if (typeof window === 'undefined' || typeof customElements === 'undefined' || customElements.get('am-rc-guided')) return;

  const EXPECTED_RELEASE_ID = 'rcgs-product-pages-2026-08-04-v3-365b3e526cb6';
  const dataCache = new Map();
  const productCache = new Map();
  let mountCounter = 0;
  const CHOICE = new Set(['required_choice', 'complete_setup_choice']);
  const MANDATORY = new Set(['required', 'required_setup_extra']);
  const COMPONENT_LABELS = {
    battery: 'Battery',
    charger: 'Charger',
    charger_power_supply: 'Charger power supply',
    complete_battery_charger_pack: 'Battery and charger package',
    transmitter_batteries: 'Transmitter batteries',
    accessory: 'Accessory',
  };

  function element(tag, attrs = {}, children = []) {
    const node = document.createElement(tag);
    for (const [key, value] of Object.entries(attrs)) {
      if (value == null || value === false) continue;
      if (key === 'className') node.className = value;
      else if (key === 'text') node.textContent = String(value);
      else if (key.startsWith('on') && typeof value === 'function') node.addEventListener(key.slice(2).toLowerCase(), value);
      else if (key === 'disabled') node.disabled = Boolean(value);
      else if (key === 'checked') node.checked = Boolean(value);
      else node.setAttribute(key, String(value));
    }
    const list = Array.isArray(children) ? children : [children];
    for (const child of list) {
      if (child == null) continue;
      node.append(child instanceof Node ? child : document.createTextNode(String(child)));
    }
    return node;
  }

  function money(pence, currency = 'GBP') {
    if (!Number.isInteger(pence)) return '—';
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(pence / 100);
  }

  function relationshipQuantity(rel) {
    return rel?.quantity === undefined ? 1 : rel.quantity;
  }

  function routeRoot() {
    const value = window.Shopify?.routes?.root;
    return typeof value === 'string' && value.startsWith('/') ? value : '/';
  }

  async function loadData(url) {
    if (!dataCache.has(url)) {
      const promise = (async () => {
        const response = await fetch(url, { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' } });
        if (!response.ok) throw new Error(`Compatibility data unavailable (${response.status})`);
        const data = await response.json();
        const contract = validatePublicDataset(data, EXPECTED_RELEASE_ID);
        if (!contract.ok) throw new Error(`Compatibility data contract failed: ${contract.errors.map(item => item.code).join(',')}`);
        return data;
      })();
      dataCache.set(url, promise);
      promise.catch(() => { if (dataCache.get(url) === promise) dataCache.delete(url); });
    }
    return dataCache.get(url);
  }

  async function resolveProduct(expected) {
    const key = `${expected.handle}|${expected.sku || expected.anchorSku}|${expected.variantId || ''}`;
    if (!productCache.has(key)) {
      const promise = (async () => {
        const product = await loadProductJs(expected.handle, { root: routeRoot() });
        const check = validateRuntimeProduct(expected, product);
        if (!check.ok) {
          const err = new Error(check.errors.map(item => item.code).join(','));
          err.codes = check.errors.map(item => item.code);
          throw err;
        }
        return check.value;
      })();
      productCache.set(key, promise);
      promise.catch(() => { if (productCache.get(key) === promise) productCache.delete(key); });
    }
    return productCache.get(key);
  }

  function groupRelationships(vehicle, relationships = vehicle.relationships) {
    const groups = new Map();
    const roleLabels = {
      required: 'Required',
      required_setup_extra: 'Required setup item',
      recommended_spare: 'Optional spare',
      replacement: 'Replacement option',
      compatible_alternative: 'Compatible alternative',
      optional: 'Optional accessory',
    };
    for (const rel of relationships) {
      const key = `${rel.role}:${rel.componentType}`;
      const component = COMPONENT_LABELS[rel.componentType] || 'Setup item';
      let label = CHOICE.has(rel.role)
        ? `Choose your ${component.toLowerCase()}`
        : `${roleLabels[rel.role] || 'Setup item'}: ${component.toLowerCase()}`;
      if (rel.role === 'compatible_alternative' && rel.componentType === 'battery' && vehicle.setup.batteryIncluded) label = 'Optional additional compatible battery';
      if (rel.role === 'replacement' && rel.componentType === 'charger' && vehicle.setup.chargerIncluded) label = 'Optional spare charger';
      if (!groups.has(key)) groups.set(key, { key, label, rels: [] });
      groups.get(key).rels.push(rel);
    }
    return [...groups.values()].sort((a, b) => Math.min(...a.rels.map(r => r.displayPriority)) - Math.min(...b.rels.map(r => r.displayPriority)));
  }

  function setupFacts(vehicle) {
    const facts = [
      ['Battery', vehicle.setup.batteryIncluded],
      ['Charger', vehicle.setup.chargerIncluded],
      ['Transmitter batteries', vehicle.setup.transmitterBatteriesIncluded],
    ];
    return element('div', { className: 'rcgs__facts' }, facts.map(([label, included]) =>
      element('div', { className: 'rcgs__fact' }, [
        element('span', { className: 'rcgs__fact-label', text: label }),
        element('span', { className: `rcgs__fact-value rcgs__fact-value--${included ? 'yes' : 'no'}`, text: included ? 'Included' : 'Not included' }),
      ])
    ));
  }

  class AMRcGuided extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.mountId = `rcgs-${++mountCounter}`;
      this.surface = this.dataset.surface === 'configurator' ? 'configurator' : 'product';
      this.accessoryCartEnabled = this.surface === 'product' && this.dataset.accessoryCartEnabled === 'true';
      this.step = 1;
      this.vehicle = null;
      this.vehicleLive = null;
      this.liveBySku = new Map();
      this.unavailable = new Set();
      this.selection = { selected: new Set(), locked: new Set() };
      this.packageActionInFlight = false;
      this.accessoryActionInFlight = false;
      this.accessoryManualReconciliation = false;
      this.accessoryMessage = null;
      if (this.dataset.enabled !== 'true') {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      this.renderLoading('Checking current products and availability…');
      this.start();
    }

    disconnectedCallback() {
      this._connected = false;
    }

    track(name, context = {}) {
      try {
        const event = makeAnalyticsEvent(name, {
          releaseId: this.data?.releaseId,
          schemaVersion: this.data?.schemaVersion,
          surface: this.surface,
          vehicleSku: this.vehicle?.anchorSku,
          currency: this.data?.currency || 'GBP',
          ...context,
        });
        window.dispatchEvent(new CustomEvent('rc-guided-selling', { detail: event }));
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ ...event });
      } catch (_) { /* Analytics must never affect guidance or commerce. */ }
    }

    renderLoading(message) {
      this.replaceChildren(element('div', { className: 'rcgs__status', role: 'status', 'aria-live': 'polite', text: message }));
    }

    renderError(message) {
      this.replaceChildren(element('div', { className: 'rcgs__status rcgs__status--error', role: 'status', 'aria-live': 'polite', text: message }));
    }

    async start() {
      try {
        this.data = await loadData(this.dataset.dataUrl);
        this.track('rcgs_data_load_succeeded');
        if (this.surface === 'product') await this.startProduct();
        else await this.startConfigurator();
      } catch (err) {
        this.track('rcgs_data_load_failed', { reasonCode: 'DATA_LOAD_FAILED', success: false });
        this.renderError('Setup guidance is temporarily unavailable. Please contact us if you need help choosing compatible equipment.');
      }
    }

    async startProduct() {
      const sku = this.dataset.anchorSku || '';
      const vehicle = findVehicleByExactSku(this.data, sku);
      if (!vehicle || String(vehicle.productId) !== String(this.dataset.productId || '')) {
        this.hidden = true;
        return;
      }
      this.vehicle = vehicle;
      try {
        this.vehicleLive = await resolveProduct({ ...vehicle, sku: vehicle.anchorSku, kind: 'vehicle' });
      } catch (_) {
        this.track('rcgs_live_check_failed', { reasonCode: 'ANCHOR_PRODUCT_FAILED', success: false });
        this.renderError('We could not confirm this vehicle’s current setup options. Please contact us and we will check them for you.');
        return;
      }
      await this.loadRelationships(vehicle);
      this.track('rcgs_impression', { itemCount: vehicle.relationships.length, success: true });
      this.renderProduct();
    }

    async startConfigurator() {
      const candidates = this.data.vehicles.filter(vehicle => vehicle.relationships.length > 0 && vehicle.setup?.completePackageEligible === true);
      const settled = await Promise.allSettled(candidates.map(async vehicle => ({
        vehicle,
        live: await resolveProduct({ ...vehicle, sku: vehicle.anchorSku, kind: 'vehicle' }),
      })));
      this.availableVehicles = settled.filter(item => item.status === 'fulfilled').map(item => item.value);
      this.track('rcgs_impression', { itemCount: this.availableVehicles.length, success: true });
      this.renderConfigurator();
    }

    async loadRelationships(vehicle) {
      this.renderLoading('Checking current accessory prices and availability…');
      const settled = await Promise.allSettled(vehicle.relationships.map(async rel => ({ rel, live: await resolveProduct({ ...rel, sku: rel.accessorySku, kind: 'accessory' }) })));
      this.liveBySku = new Map();
      this.unavailable = new Set();
      for (let i = 0; i < settled.length; i += 1) {
        const item = settled[i];
        const rel = vehicle.relationships[i];
        if (item.status === 'fulfilled') this.liveBySku.set(rel.accessorySku, item.value.live);
        else this.unavailable.add(rel.accessorySku);
      }
      this.uiVehicle = { ...vehicle, relationships: vehicle.relationships.filter(rel => this.liveBySku.has(rel.accessorySku)) };
      this.selection = this.surface === 'product' ? createInitialAccessorySelection(this.uiVehicle) : createInitialSelection(this.uiVehicle);
      const success = this.liveBySku.size === vehicle.relationships.length;
      this.track(success ? 'rcgs_live_check_succeeded' : 'rcgs_live_check_failed', {
        reasonCode: success ? 'ALL_ITEMS_CONFIRMED' : 'ONE_OR_MORE_ITEMS_UNAVAILABLE',
        itemCount: this.liveBySku.size,
        success,
      });
    }

    packageState() {
      if (!this.vehicle || !this.vehicleLive || !this.uiVehicle) return { ok: false, reason: 'ANCHOR_NOT_READY' };
      if (this.vehicle.setup?.completePackageEligible !== true || this.vehicle.setup.missingRequiredComponents?.length !== 0) return { ok: false, reason: 'PACKAGE_INCOMPLETE' };
      const selection = validateSelection(this.uiVehicle, this.selection);
      if (!selection.ok) return { ok: false, reason: selection.errors[0]?.code || 'SELECTION_INVALID' };
      for (const rel of this.vehicle.relationships) {
        if (MANDATORY.has(rel.role) && !this.liveBySku.has(rel.accessorySku)) return { ok: false, reason: 'MANDATORY_ITEM_UNAVAILABLE' };
      }
      for (const group of groupRelationships(this.vehicle).filter(group => group.rels.some(rel => CHOICE.has(rel.role)))) {
        if (!group.rels.some(rel => this.liveBySku.has(rel.accessorySku))) return { ok: false, reason: 'REQUIRED_CHOICE_UNAVAILABLE' };
      }
      return { ok: true, reason: null };
    }

    selectedLines() {
      if (!this.vehicleLive) return [];
      const lines = [{ sku: this.vehicle.anchorSku, title: this.vehicleLive.title || this.vehicle.title, componentType: 'Vehicle', pricePence: this.vehicleLive.pricePence }];
      for (const rel of customerRelationships(this.uiVehicle || this.vehicle)) {
        if (!this.selection.selected.has(rel.accessorySku)) continue;
        const live = this.liveBySku.get(rel.accessorySku);
        if (live) lines.push({ sku: rel.accessorySku, title: live.title || rel.title, componentType: COMPONENT_LABELS[rel.componentType] || 'Accessory', pricePence: live.pricePence });
      }
      return lines;
    }

    totalPence() {
      return this.selectedLines().reduce((sum, line) => sum + (Number.isInteger(line.pricePence) ? line.pricePence : 0), 0);
    }

    renderConfiguratorOptionGroups() {
      if (!this.vehicle.relationships.length) return element('div', { className: 'rcgs__empty', text: 'No additional source-verified setup items are currently available online.' });
      const wrapper = element('div');
      for (const group of groupRelationships(this.vehicle)) {
        const fieldset = element('fieldset', { className: 'rcgs__group' });
        fieldset.append(element('legend', { className: 'rcgs__legend', text: group.label }));
        const list = element('div', { className: 'rcgs__option-list' });
        for (const rel of group.rels) {
          const live = this.liveBySku.get(rel.accessorySku);
          const unavailable = !live;
          const selected = this.selection.selected.has(rel.accessorySku);
          const locked = MANDATORY.has(rel.role);
          const isChoice = CHOICE.has(rel.role);
          const input = element('input', {
            className: 'rcgs__control',
            type: isChoice ? 'radio' : 'checkbox',
            name: isChoice ? `${this.mountId}-${group.key}` : `${this.mountId}-${rel.accessorySku}`,
            value: rel.accessorySku,
            checked: selected,
            disabled: unavailable || locked,
            'aria-label': live ? `${live.title || rel.title}, ${money(live.pricePence, this.data.currency)}` : `${rel.title}, currently unavailable`,
          });
          if (!unavailable && !locked) {
            input.addEventListener('change', () => {
              const action = isChoice ? { type: 'SELECT_CHOICE', sku: rel.accessorySku } : { type: 'TOGGLE_OPTIONAL', sku: rel.accessorySku };
              const result = reduceSelection(this.uiVehicle, this.selection, action);
              this.selection = result.state;
              this.track(isChoice ? 'rcgs_required_choice_changed' : (this.selection.selected.has(rel.accessorySku) ? 'rcgs_accessory_selected' : 'rcgs_accessory_deselected'), {
                accessorySku: rel.accessorySku,
                componentType: rel.componentType,
                role: rel.role,
              });
              this.renderCurrent();
            });
          }
          const image = live?.image
            ? element('img', { className: 'rcgs__option-image', src: live.image, alt: '', loading: 'lazy', decoding: 'async' })
            : element('span', { className: 'rcgs__option-image rcgs__option-image--empty', 'aria-hidden': 'true', text: 'No image' });
          const title = element('span', { className: 'rcgs__option-title', text: live?.title || rel.title });
          if (locked && !unavailable) title.append(element('span', { className: 'rcgs__badge', text: 'Required' }));
          const copy = element('span', { className: 'rcgs__option-copy' }, [
            title,
            element('span', { className: 'rcgs__option-note', text: unavailable ? 'Currently unavailable online' : `${rel.customerNote}${relationshipQuantity(rel) > 1 ? ` Quantity: ${relationshipQuantity(rel)}.` : ''}` }),
          ]);
          const price = element('span', { className: 'rcgs__option-price', text: unavailable ? 'Unavailable' : money(live.pricePence, this.data.currency) });
          const label = element('label', {
            className: `rcgs__option${selected ? ' rcgs__option--selected' : ''}${locked ? ' rcgs__option--locked' : ''}${unavailable ? ' rcgs__option--unavailable' : ''}`,
          }, [input, image, copy, price]);
          list.append(label);
        }
        fieldset.append(list);
        wrapper.append(fieldset);
      }
      return wrapper;
    }

    actionArea() {
      const state = this.packageState();
      const adapter = window.AMRcCartAdapter;
      const adapterReady = Boolean(this.data.rules?.liveCartEnabled === true && adapter && adapter.enabled === true && adapter.releaseId === this.data.releaseId && typeof adapter.submit === 'function');
      const button = element('button', {
        className: 'rcgs__button',
        type: 'button',
        disabled: !state.ok || !adapterReady,
        text: adapterReady ? 'Add complete package to cart' : state.ok ? 'Package checkout is not enabled' : 'Complete package cannot be confirmed',
      });
      if (state.ok && adapterReady) button.addEventListener('click', () => this.handlePackageAction(button));
      const note = !state.ok
        ? 'A required item cannot currently be confirmed online, so package checkout is safely blocked.'
        : adapterReady
          ? 'Every item will be checked again before one complete package is added.'
          : 'All required items are currently confirmed. Package checkout is not enabled for this candidate, but the products can be bought separately.';
      return element('div', { className: 'rcgs__actions' }, [
        element('div', { className: 'rcgs__total' }, [element('span', { text: 'Current package total' }), element('span', { text: money(this.totalPence(), this.data.currency) })]),
        button,
        element('p', { className: 'rcgs__action-note', text: note }),
      ]);
    }

    async handlePackageAction(button) {
      if (this.packageActionInFlight) return;
      this.packageActionInFlight = true;
      this.querySelectorAll('button, input').forEach(control => { control.disabled = true; });
      const adapter = window.AMRcCartAdapter;
      if (this.data.rules?.liveCartEnabled !== true || !adapter || adapter.enabled !== true || adapter.releaseId !== this.data.releaseId) { this.packageActionInFlight = false; this.renderCurrent(); return; }
      button.disabled = true;
      button.textContent = 'Rechecking every item…';
      const planResult = buildPackagePlan(this.uiVehicle, this.selection);
      if (!planResult.ok) {
        button.textContent = 'Package could not be prepared';
        this.track('rcgs_package_action_blocked', { reasonCode: 'SELECTION_INVALID', success: false });
        this.packageActionInFlight = false;
        this.renderCurrent();
        return;
      }
      const plan = [{ ...planResult.value[0], productId: this.vehicle.productId, handle: this.vehicle.handle, sku: this.vehicle.anchorSku }, ...planResult.value.slice(1)];
      const prepared = await preparePackage(plan, { root: routeRoot(), releaseId: this.data.releaseId, completePackageEligible: this.vehicle.setup?.completePackageEligible === true });
      if (!prepared.ok) {
        button.textContent = 'Availability changed — please review';
        this.track('rcgs_package_action_blocked', { reasonCode: prepared.errors?.[0]?.code || 'REVALIDATION_FAILED', success: false });
        await this.loadRelationships(this.vehicle);
        this.packageActionInFlight = false;
        this.renderCurrent();
        return;
      }
      const result = await adapter.submit(prepared);
      if (!result?.ok) {
        const ambiguousTimeout = result?.code === 'CART_TIMEOUT_RECONCILIATION_REQUIRED';
        button.disabled = ambiguousTimeout;
        button.textContent = ambiguousTimeout ? 'Check your cart before trying again' : 'Try adding the complete package again';
        this.track('rcgs_package_action_blocked', { reasonCode: result?.code || 'CART_FAILED', success: false });
        if (!ambiguousTimeout) { this.packageActionInFlight = false; this.renderCurrent(); }
        return;
      }
      this.track('rcgs_package_reviewed', { itemCount: prepared.payload.items.length, valuePence: this.totalPence(), success: true });
      window.location.assign(`${routeRoot()}cart`);
    }

    renderProductOptionGroups() {
      if (!this.vehicle.relationships.length) return element('div', { className: 'rcgs__empty', text: 'No compatible accessories are currently available online.' });
      const wrapper = element('div');
      const groups = groupRelationships(this.vehicle, this.vehicle.relationships).sort((a, b) => (a.rels.some(rel => rel.accessorySku === 'O-GAC65PS') ? -1 : b.rels.some(rel => rel.accessorySku === 'O-GAC65PS') ? 1 : Math.min(...a.rels.map(rel => rel.displayPriority)) - Math.min(...b.rels.map(rel => rel.displayPriority))));
      for (const group of groups) {
        const fieldset = element('fieldset', { className: 'rcgs__group' });
        fieldset.append(element('legend', { className: 'rcgs__legend', text: `${COMPONENT_LABELS[group.rels[0]?.componentType] || 'Accessory'} options` }));
        const list = element('div', { className: 'rcgs__option-list' });
        for (const rel of group.rels) {
          const live = this.liveBySku.get(rel.accessorySku);
          const unavailable = !live;
          const selected = this.selection.selected.has(rel.accessorySku);
          const input = element('input', {
            className: 'rcgs__control', type: 'checkbox',
            name: `${this.mountId}-${rel.accessorySku}`,
            value: rel.accessorySku, checked: selected, disabled: unavailable || this.accessoryActionInFlight || this.accessoryManualReconciliation,
            'aria-label': live ? `${live.title || rel.title}, ${money(live.pricePence, this.data.currency)}` : `${rel.title}, currently unavailable`,
          });
          if (!unavailable && !this.accessoryActionInFlight && !this.accessoryManualReconciliation) input.addEventListener('change', () => {
            this.selection = reduceAccessorySelection(this.uiVehicle, this.selection, { type: 'TOGGLE_ACCESSORY', sku: rel.accessorySku }).state;
            this.accessoryMessage = null;
            this.renderCurrent();
          });
          const image = live?.image
            ? element('img', { className: 'rcgs__option-image', src: live.image, alt: '', loading: 'lazy', decoding: 'async' })
            : element('span', { className: 'rcgs__option-image rcgs__option-image--empty', 'aria-hidden': 'true', text: 'No image' });
          const title = element('span', { className: 'rcgs__option-title', text: live?.title || rel.title });
          if (rel.accessorySku === 'O-GAC65PS') title.append(element('span', { className: 'rcgs__badge', text: 'Strongly recommended' }));
          const note = rel.accessorySku === 'O-GAC65PS'
            ? 'The included charger needs a suitable QC 2.0/3.0 18W+ USB power adaptor. If you already have one, leave this unticked.'
            : rel.customerNote;
          const visibleNote = unavailable ? `Currently unavailable online. ${note}` : `${note}${relationshipQuantity(rel) > 1 ? ` Quantity: ${relationshipQuantity(rel)}.` : ''}`;
          const copy = element('span', { className: 'rcgs__option-copy' }, [title, element('span', { className: 'rcgs__option-note', text: visibleNote })]);
          const price = element('span', { className: 'rcgs__option-price', text: unavailable ? 'Unavailable' : money(live.pricePence, this.data.currency) });
          list.append(element('label', { className: `rcgs__option${selected ? ' rcgs__option--selected' : ''}${unavailable ? ' rcgs__option--unavailable' : ''}` }, [input, image, copy, price]));
        }
        fieldset.append(list);
        wrapper.append(fieldset);
      }
      return wrapper;
    }

    selectedAccessoryTotalPence() {
      return customerRelationships(this.uiVehicle || this.vehicle).reduce((sum, rel) => {
        const live = this.selection.selected.has(rel.accessorySku) ? this.liveBySku.get(rel.accessorySku) : null;
        return sum + (Number.isInteger(live?.pricePence) ? live.pricePence * relationshipQuantity(rel) : 0);
      }, 0);
    }

    productActionArea() {
      if (!this.accessoryCartEnabled) return null;
      const selection = validateAccessorySelection(this.uiVehicle, this.selection);
      const hasSelection = this.selection.selected.size > 0;
      const adapter = window.AMRcAccessoryCartAdapter;
      const adapterReady = Boolean(this.accessoryCartEnabled && this.data.rules?.liveAccessoryCartEnabled === true && this.data.rules?.accessoryCartReleaseState === 'live_approved' && adapter?.enabled === true && adapter.releaseId === this.data.releaseId && typeof adapter.submit === 'function');
      const locked = this.accessoryActionInFlight || this.accessoryManualReconciliation;
      const buttonText = this.accessoryManualReconciliation
        ? 'Check your cart before trying again'
        : hasSelection ? 'Add selected accessories to cart' : 'Select accessories to add';
      const button = element('button', { className: 'rcgs__button', type: 'button', disabled: locked || !hasSelection || !selection.ok || !adapterReady, text: buttonText });
      if (!locked && hasSelection && selection.ok && adapterReady) button.addEventListener('click', () => this.handleAccessoryAction(button));
      const note = this.accessoryMessage || 'Only the ticked accessories will be added. The vehicle’s own Add to cart button is unchanged.';
      return element('div', { className: 'rcgs__actions' }, [
        element('div', { className: 'rcgs__total' }, [element('span', { text: 'Selected accessories total' }), element('span', { text: money(this.selectedAccessoryTotalPence(), this.data.currency) })]),
        button,
        element('p', { className: 'rcgs__action-note', role: 'status', 'aria-live': 'polite', text: note }),
      ]);
    }

    async handleAccessoryAction(button) {
      if (this.accessoryActionInFlight || this.accessoryManualReconciliation) return;
      this.accessoryActionInFlight = true;
      this.accessoryMessage = null;
      this.querySelectorAll('button, input').forEach(control => { control.disabled = true; });
      const adapter = window.AMRcAccessoryCartAdapter;
      if (this.surface !== 'product' || !this.accessoryCartEnabled || this.data.rules?.liveAccessoryCartEnabled !== true || this.data.rules?.accessoryCartReleaseState !== 'live_approved' || adapter?.enabled !== true || adapter.releaseId !== this.data.releaseId) {
        this.accessoryActionInFlight = false;
        this.accessoryMessage = 'Accessory checkout is temporarily unavailable. Nothing was added.';
        this.renderCurrent();
        return;
      }
      const plan = buildAccessoryPlan(this.uiVehicle, this.selection);
      if (!plan.ok) {
        this.accessoryActionInFlight = false;
        this.accessoryMessage = 'Select at least one available accessory. Nothing was added.';
        this.renderCurrent();
        return;
      }
      button.textContent = 'Rechecking selected accessories…';
      const prepared = await prepareAccessories(plan.value, { root: routeRoot(), releaseId: this.data.releaseId, surface: 'product' });
      if (!prepared.ok) {
        await this.loadRelationships(this.vehicle);
        this.accessoryActionInFlight = false;
        this.accessoryMessage = 'Availability changed while we checked. Nothing was added; please review the current options.';
        this.renderCurrent();
        return;
      }
      const result = await adapter.submit(prepared);
      if (!result?.ok) {
        const ambiguous = ['CART_TIMEOUT_RECONCILIATION_REQUIRED', 'CART_RECONCILIATION_REQUIRED'].includes(result?.code);
        if (ambiguous) {
          this.accessoryManualReconciliation = true;
          this.accessoryMessage = 'We could not confirm whether those accessories were added. Please check your cart before trying again.';
          this.renderCurrent();
          return;
        }
        this.accessoryActionInFlight = false;
        this.accessoryMessage = 'We could not add those accessories. Nothing was added; please review and try again.';
        this.renderCurrent();
        return;
      }
      window.location.assign(`${routeRoot()}cart`);
    }

    renderProduct() {
      const shell = element('section', { className: 'rcgs rcgs--product', 'aria-labelledby': `${this.mountId}-title` });
      shell.append(element('header', { className: 'rcgs__header' }, [
        element('p', { className: 'rcgs__eyebrow', text: 'Source-checked compatibility' }),
        element('h2', { className: 'rcgs__title', id: `${this.mountId}-title`, text: 'Complete your setup' }),
        element('p', { className: 'rcgs__intro', text: 'See what is included, then choose only exact compatible items.' }),
      ]));
      shell.append(element('div', { className: 'rcgs__body' }, [
        setupFacts(this.vehicle),
        element('p', { className: 'rcgs__summary', text: this.vehicle.setup.summary }),
        this.renderProductOptionGroups(),
        this.productActionArea(),
      ]));
      this.replaceChildren(shell);
    }

    renderSidebar() {
      const labels = ['Choose a vehicle', 'Complete your setup', 'Review package'];
      const steps = element('ol', { className: 'rcgs__steps' });
      labels.forEach((label, index) => {
        const number = index + 1;
        steps.append(element('li', { className: `rcgs__step${number === this.step ? ' rcgs__step--active' : ''}${number < this.step ? ' rcgs__step--done' : ''}` }, [
          element('span', { className: 'rcgs__step-number', text: number < this.step ? '✓' : number }),
          element('span', { text: label }),
        ]));
      });
      return element('aside', { className: 'rcgs__sidebar', 'aria-label': 'Configurator progress' }, [
        steps,
        element('p', { className: 'rcgs__sidebar-label', text: 'Running total' }),
        element('p', { className: 'rcgs__sidebar-total', text: money(this.totalPence(), this.data.currency) }),
      ]);
    }

    renderVehicleStep() {
      const panel = element('section', { className: 'rcgs__panel', 'aria-labelledby': `${this.mountId}-panel-title` }, [
        element('h2', { className: 'rcgs__panel-title', id: `${this.mountId}-panel-title`, text: 'Choose an RC vehicle' }),
        element('p', { className: 'rcgs__panel-subtitle', text: 'Everything needed for a complete setup has been source-checked for the vehicles shown.' }),
      ]);
      if (!this.availableVehicles?.length) {
        panel.append(element('div', { className: 'rcgs__empty', text: 'No configurator vehicles could be confirmed online at the moment.' }));
        return panel;
      }
      const grid = element('div', { className: 'rcgs__vehicle-grid' });
      for (const { vehicle, live } of this.availableVehicles) {
        const image = live.image ? element('img', { className: 'rcgs__vehicle-image', src: live.image, alt: '', loading: 'lazy' }) : element('span', { className: 'rcgs__vehicle-image' });
        const button = element('button', { className: 'rcgs__vehicle', type: 'button' }, [
          image,
          element('span', { className: 'rcgs__vehicle-copy' }, [
            element('span', { className: 'rcgs__vehicle-vendor', text: vehicle.vendor }),
            element('span', { className: 'rcgs__vehicle-title', text: live.title || vehicle.title }),
            element('span', { className: 'rcgs__vehicle-price', text: money(live.pricePence, this.data.currency) }),
            element('span', { className: 'rcgs__vehicle-select', text: 'Select this vehicle' }),
          ]),
        ]);
        button.addEventListener('click', async () => {
          this.vehicle = vehicle;
          this.vehicleLive = live;
          this.step = 2;
          this.track('rcgs_vehicle_selected', { vehicleSku: vehicle.anchorSku, step: 1 });
          await this.loadRelationships(vehicle);
          this.renderConfigurator();
        });
        grid.append(button);
      }
      panel.append(grid);
      return panel;
    }

    renderSetupStep() {
      const panel = element('section', { className: 'rcgs__panel', 'aria-labelledby': `${this.mountId}-panel-title` }, [
        element('h2', { className: 'rcgs__panel-title', id: `${this.mountId}-panel-title`, text: 'Complete your setup' }),
        element('p', { className: 'rcgs__panel-subtitle', text: this.vehicle.title }),
      ]);
      const setup = element('div', { className: 'rcgs__setup-grid' }, [
        element('div', {}, [setupFacts(this.vehicle), element('p', { className: 'rcgs__summary', text: this.vehicle.setup.summary }), this.renderConfiguratorOptionGroups()]),
        element('div', {}, [this.renderMiniReview()]),
      ]);
      panel.append(setup);
      panel.append(element('div', { className: 'rcgs__nav' }, [
        element('button', { className: 'rcgs__button rcgs__button--secondary', type: 'button', text: 'Back to vehicles', onclick: () => { this.step = 1; this.renderConfigurator(); } }),
        element('button', { className: 'rcgs__button', type: 'button', text: 'Review package', disabled: !this.packageState().ok, onclick: () => { this.step = 3; this.track('rcgs_step_viewed', { step: 3 }); this.renderConfigurator(); } }),
      ]));
      return panel;
    }

    renderMiniReview() {
      const box = element('div', { className: 'rcgs__status' }, [element('strong', { text: 'Your current package' })]);
      const lines = this.selectedLines();
      const list = element('div', { className: 'rcgs__review' });
      for (const line of lines) list.append(element('div', { className: 'rcgs__review-line' }, [
        element('span', {}, [element('span', { className: 'rcgs__review-kind', text: line.componentType }), element('span', { className: 'rcgs__review-title', text: line.title })]),
        element('span', { className: 'rcgs__option-price', text: money(line.pricePence, this.data.currency) }),
      ]));
      box.append(list);
      return box;
    }

    renderReviewStep() {
      const panel = element('section', { className: 'rcgs__panel', 'aria-labelledby': `${this.mountId}-panel-title` }, [
        element('h2', { className: 'rcgs__panel-title', id: `${this.mountId}-panel-title`, text: 'Review your package' }),
        element('p', { className: 'rcgs__panel-subtitle', text: 'Current online prices and availability have been checked. Nothing is added until the complete package passes a final check.' }),
        this.renderMiniReview(),
        this.actionArea(),
      ]);
      panel.append(element('div', { className: 'rcgs__nav' }, [
        element('button', { className: 'rcgs__button rcgs__button--secondary', type: 'button', text: 'Adjust setup', onclick: () => { this.step = 2; this.renderConfigurator(); } }),
      ]));
      return panel;
    }

    renderConfigurator() {
      const shell = element('section', { className: 'rcgs rcgs--configurator', 'aria-labelledby': `${this.mountId}-config-title` }, [
        element('header', { className: 'rcgs__config-head' }, [
          element('p', { className: 'rcgs__eyebrow', text: 'Access Models RC configurator' }),
          element('h1', { className: 'rcgs__title', id: `${this.mountId}-config-title`, text: 'Build a compatible RC package' }),
          element('p', { className: 'rcgs__intro', text: 'Choose a vehicle, see exactly what is included, then add only source-checked compatible equipment.' }),
        ]),
      ]);
      const panel = this.step === 1 ? this.renderVehicleStep() : this.step === 2 ? this.renderSetupStep() : this.renderReviewStep();
      shell.append(element('div', { className: 'rcgs__layout' }, [this.renderSidebar(), panel]));
      this.replaceChildren(shell);
    }

    renderCurrent() {
      if (this.surface === 'product') this.renderProduct();
      else this.renderConfigurator();
    }
  }

  customElements.define('am-rc-guided', AMRcGuided);
})();
if(typeof globalThis!=='undefined')globalThis.__AM_RC_PRODUCT_PAGE_VALIDATE__=validatePublicDataset;
})();
